import React from 'react'
import { Controller } from 'react-hook-form'
import { DateTimePicker } from 'app/components/atoms'
import { useTranslation } from 'app/i18n/client'

import { Control } from 'react-hook-form'
import { DateTimePickerProps } from 'app/components/atoms/DateTimePicker'

interface FormDateTimePickerProps extends DateTimePickerProps {
  control?: Control
  name: string
  defaultValue?: Date | undefined
  error?: any
  controllerProps?: any
}

const FormDateTimePicker = ({
  controllerProps,
  control,
  name,
  defaultValue,
  error,
  placeHolder,
  ...rest
}: FormDateTimePickerProps) => {
  const { t } = useTranslation()

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value } }) => (
        <DateTimePicker
          value={value}
          placeHolder={placeHolder}
          onChange={onChange}
          isError={!!error}
          errorMessage={t(error?.message)}
          {...rest}
        />
      )}
      name={name}
      defaultValue={defaultValue}
      {...controllerProps}
    />
  )
}

export default FormDateTimePicker
